import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  position: relative;
  display: block;
  inline-size: ${spacing(100)};
  overflow: hidden;
  border-radius: ${spacing(3)};
  margin-block-end: ${spacing(1)};
  block-size: auto;
  background-color: ${cssTheme.default.day.background};
  z-index: 6;
`

export const image = css`
  inline-size: 100%;
  overflow: hidden;
  block-size: auto;
`
